var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTextContent = function SvgTextContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FF855F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.232 31.66H13.066c-.65 0-1.084-.433-1.084-1.083v-19.5c0-.65.434-1.083 1.084-1.083h9.75l6.5 6.5v14.083c0 .65-.434 1.083-1.084 1.083ZM23.9 26.244c0-.65-.433-1.084-1.083-1.084h-6.5c-.65 0-1.084.434-1.084 1.084 0 .65.434 1.083 1.084 1.083h6.5c.65 0 1.083-.433 1.083-1.083Zm2.167-5.417c0-.65-.434-1.083-1.084-1.083h-8.666c-.65 0-1.084.433-1.084 1.083 0 .65.434 1.084 1.084 1.084h8.666c.65 0 1.084-.434 1.084-1.084Zm0-5.416c0-.65-.434-1.084-1.084-1.084h-8.666c-.65 0-1.084.434-1.084 1.084 0 .65.434 1.083 1.084 1.083h8.666c.65 0 1.084-.433 1.084-1.083Z",
    fill: "url(#text-content_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.899 16.494h5.416l-6.5-6.5v5.417c0 .65.434 1.083 1.084 1.083Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-content_svg__a",
    x1: 20.649,
    y1: 9.994,
    x2: 20.649,
    y2: 31.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })))));
};

export default SvgTextContent;